import classNames from "classnames";
import React, { memo } from "react";
import { CSSTransition } from "react-transition-group";
import "./UniversalInput.scss";

import { ReactComponent as CloseIcon } from 'static/icons/close.svg';

const UniversalInput = memo(
  ({
    label,
    id,
    name,
    type,
    placeholder,
    onChangeValue,
    value,
    required,
    leftIcon,
    isClearButtonActive,
    onClearSearch,
  }) => {
    const handleChange = (e) => {
      if (name) {
        onChangeValue?.(e.target.value, name);
      } else {
        onChangeValue?.(e.target.value);
      }
    };

    return (
      <div className="universal-input">
        {!!label &&
          <label
            className="universal-input__label"
            htmlFor={id}
          >
            {label}
          </label>
        }

        {!!leftIcon &&
          <div className="universal-input__icon--left">
            {leftIcon}
          </div>
        }

        <CSSTransition
          in={isClearButtonActive && !!value}
          timeout={150}
          unmountOnExit
          classNames="animation"
        >
          <div
            className="universal-input__icon--clear"
            onClick={onClearSearch}
          >
            <CloseIcon />
          </div>
        </CSSTransition>
        
        <input
          className={classNames({
            "universal-input__input": true,
            "universal-input__input--icon-left": !!leftIcon,
          })}
          
          type={type}
          name={name}
          id={id}
          placeholder={placeholder}
          onChange={handleChange}
          value={value}
          required={required}
        />
      </div>
    );
  }
);

export default UniversalInput;
